import { render, staticRenderFns } from "./FormBuilderInfoRow.vue?vue&type=template&id=7a6df80a&"
import script from "./FormBuilderInfoRow.vue?vue&type=script&lang=js&"
export * from "./FormBuilderInfoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports